import React from "react";
import Icon from "../icons/Icon";
import { useSelectMenu } from "../../hooks/useSelectMenu";

function summaryOf(values, options, emptyLabel) {
  if (values.length === 0) return emptyLabel;
  if (values.length === 1) {
    return options.find((option) => option.value === values[0])?.label ?? values[0];
  }
  return `${values.length} selecionados`;
}

function MultiSelect({ label, values, options, onChange, emptyLabel }) {
  const {
    ids,
    shellRef,
    triggerRef,
    optionRefs,
    open,
    setOpen,
    openAt,
    insideDialog,
    handleTriggerKeyDown,
    handleOptionKeyDown,
  } = useSelectMenu(options.length);

  const firstSelectedIndex = options.findIndex((option) => values.includes(option.value));

  // Marcar não fecha o menu: quem abriu para escolher vários escolheria um só.
  const toggle = (option) =>
    onChange(
      values.includes(option.value)
        ? values.filter((value) => value !== option.value)
        : [...values, option.value],
    );

  return (
    <>
      {open && insideDialog && <div className="select-scrim" aria-hidden="true" />}

      <div className="select-shell" ref={shellRef}>
        <span className="sr-only" id={ids.labelId}>
          {label}
        </span>

        <button
          className={open ? "select-trigger is-open" : "select-trigger"}
          type="button"
          ref={triggerRef}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-controls={ids.listId}
          aria-labelledby={`${ids.labelId} ${ids.valueId}`}
          onClick={() => (open ? setOpen(false) : openAt(firstSelectedIndex))}
          onKeyDown={(event) => handleTriggerKeyDown(event, firstSelectedIndex)}
        >
          <span className="select-value" id={ids.valueId}>
            {summaryOf(values, options, emptyLabel)}
          </span>
          <Icon className="select-caret" name="chevron-down" size={16} />
        </button>

        {open && (
          <ul
            className="select-menu"
            role="listbox"
            aria-multiselectable="true"
            id={ids.listId}
            aria-labelledby={ids.labelId}
          >
            {options.map((option, index) => {
              const selected = values.includes(option.value);

              return (
                <li
                  key={option.value}
                  className={selected ? "select-option is-selected" : "select-option"}
                  role="option"
                  aria-selected={selected}
                  tabIndex={-1}
                  ref={(node) => {
                    optionRefs.current[index] = node;
                  }}
                  onClick={() => toggle(option)}
                  onKeyDown={(event) =>
                    handleOptionKeyDown(event, index, (target) => toggle(options[target]))
                  }
                >
                  <Icon className="select-check" name="check" size={16} aria-hidden="true" />
                  {option.label}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
}

export default MultiSelect;
